<template>
<div class="wrap-container">
  <div class="header Mini-Header-Model" v-if="!isApp">
    <a href="javascript:;" onclick="reload()" class="back"></a>
    <img onclick="reload()" src="//www.med66.com/images/2017lammu_logo.png" style="position: absolute;top: 0.26rem;left: 0.8rem;width: 2.5rem;" alt="医学教育网">
    <h1>在线模考系统</h1>
    <div class="login">
      <a href="javascript:void (0)" class="noLogin" @click="gotoLogin()" v-show="noLogin">登录</a>
      <a href="//m.med66.com/m_member/mycenter/mysubject.shtm" class="yesLogin" v-show="!noLogin">
        <img :src="iconUrl">
      </a>
    </div>
  </div>
  <div class="in-banner">
    <img src="https://m.med66.com/qz/resources/images/qz/moniExam/pic_04.jpg">
    <p class="ctxt">随时复习 精准练习 持续更新 解析透彻</p>
  </div>
  <div class="in-record clearfix" >
    <a href="javascript:void(0)" class="btn fl" @click="jumpToRecord">我的做题记录</a>
    <a href="javascript:void(0)" class="btn btn02 fr" @click="jumpToCollect">我的试题收藏</a>
  </div>
  <div class="in-examRoom">
    <!--辅导导航-->
    <div v-swiper:kmSwiper="kmSwiperOpt" class="eTit">
      <ul class="swiper-wrapper">
        <li
          v-for="(item,index) in majorType"
          :key="index"
          class="swiper-slide"
          :class="{'on':item.isChoose===1}"
          @click="getCategoryMajorsApi(item.categoryID,'',index)">
          <a href="javascript:void (0)">{{ item.categoryName }}</a>
          <i></i>
        </li>
      </ul>
    </div>
    <!--辅导导航 end-->

    <!--    新增解锁题库会员需求（护士，卫生）-->
    <div class="yueKao" v-if="buyButtonFlag">
      <span style="color: #FF6702;">{{otherButtonText}}</span>
      <div class="right-box">
        <a class="limit_btn" style="cursor: pointer" @click="toBuy()"
        >{{buyButtonText}}
          <i class="icon"><img src="@/assets/images/hot.png" alt="" /></i>
        </a>
      </div>
    </div>

    <!--科目专区-->
    <div class="eBox" style="margin-top: 10px">
      <div class="subtit" >
        <div v-swiper:subSwiper="subSwiperOpt">
          <ul class="swiper-wrapper">
            <li
              v-for="(item,index) in medMajors"
              :key="index"
              class="swiper-slide"
              :class="{'on':item.isChoose===1}"
              @click="getPapersApi(item.majorID,item.courseID,item.siteCourseID,index)">
              <a href="javascript:void (0)">{{ item.showName }}</a>
            </li>
          </ul>
        </div>
        <div class="more-btn" v-if="medMajors && medMajors.length>3" @click="openDia"><i class="jian"></i></div>
      </div>
      <div v-if="paperList.length"  class="listCon dzq">
        <div class="list" v-for="(item,index) in paperList" :key="index">
          <div class="ltop">{{ item.paperViewName }}<br></div>
          <div class="lcen">总分{{item.totalScore}}分，共{{ item.quesCount }}道题</div>
          <a href="javascript:void(0)" class="lbtn" @click="goToStep(item)">进入考场</a>
        </div>
      </div>
      <div v-else class="list-style-none">
        <span>预计近期开通</span>
      </div>
    </div>
    <!--科目专区 end-->

    <!--功能介绍-->
    <div class="in-functionIntroduce">
      <div class="tit">七大功能介绍</div>
      <div class="listCon">
        <div class="list">
          <div class="ltop">仿真试题</div>
          <div class="lcen">题型全面覆盖考点<br>贴近考试助力提升</div>
        </div>
        <div class="list">
          <div class="ltop">试题解析</div>
          <div class="lcen">习题的答案及解析<br>了解自己的薄弱点</div>
        </div>
        <div class="list">
          <div class="ltop">错题记录</div>
          <div class="lcen">针对性的再次选做<br>巩固薄弱知识点</div>
        </div>
        <div class="list">
          <div class="ltop">排行榜</div>
          <div class="lcen">提供试卷排行榜<br>详细了解复习程度</div>
        </div>
        <div class="list">
          <div class="ltop">自动判分</div>
          <div class="lcen">客观题部分系统自动<br>批阅显示客观题得分</div>
        </div>
        <div class="list">
          <div class="ltop">网络辅导</div>
          <div class="lcen">针对不同学员开设不同班次<br>有效提升通过率</div>
        </div>
        <div class="list">
          <div class="ltop">题库软件</div>
          <div class="lcen">大量题库、人机对话<br>免费试用，持续更新</div>
        </div>
      </div>
    </div>
    <!--功能介绍 end-->
  </div>

  <!--选择科目弹框-->
  <div class="choice-dia">
    <div class="mask" v-show="show"></div>
    <transition name="fade">
      <div class="more-pop" v-show="show">
        <a href="javascript:void(0)" class="xx close" @click="closeMask"></a>
        <div class="tit">选择科目</div>
        <div class="listBox clearfix">
          <a class="listBtn"
             :class="{'on':item.isChoose===1}"
             href="javascript:void (0)"
             v-for="(item,index) in medMajors"
             :key="index"
             @click="getPapersApi(item.majorID,item.courseID,item.siteCourseID,index)">{{ item.showName }}</a>
        </div>
      </div>
    </transition>
  </div>




</div>
</template>
<script>
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {getCategoryMajors,getPapers} from '@/api'
import {getCookie, setCookie} from "@/utils";
import axios from 'axios'


export default {
  name: 'Entry',
  directives: {
    swiper: directive
  },
  data(){
    return{
      kmSwiperOpt: {
        slidesPerView: 'auto',
        freeMode: true,
        observer: true,
        observeParents: true,
        initialSlide:1
      },
      subSwiperOpt:{
        slidesPerView: 'auto',
        freeMode: true,
        observer: true,
        observeParents: true,
        initialSlide:1
      },
      majorType:[],
      medMajors:[],
      paperList:[],
      iconUrl:'',
      noLogin:true,
      show:false,
      isApp:false,
      categoryID:1,
      majorID:0,
      courseEduID:0,
      eduSubjectID:0,
      courseID:0,
      buyButtonFlag:false,
      otherButtonText:'',
      buyButtonText:''
    }
  },
  mounted() {
    const { index,urlName } = this.$route.query
    this.getCategoryMajorsApi(index,urlName)

    window.CDEL.loginStatus((cb) => {
      if (cb.loginFlag) {
        this.iconUrl = cb.iconUrl
        this.noLogin = false
        this.$forceUpdate()
      } else {
        // 未登录
        this.noLogin = true
      }
    })
    this.isApp = window.CDEL.isApp || !!window.CDEL.isWxMini


  },
  methods:{
    toBuy() {
      let _url = ''
      _url =
          `https://m.med66.com/freetiku/?eduSubjectID=${this.eduSubjectID}`
      window.open(_url, '_blank')
    },
    gotoLogin(){
      window.CDEL.login()
    },
    getCategoryMajorsApi(index,urlName,idx){
      this.medMajors = []
      this.paperList = []
      let params = {
        index:index,
        urlName:urlName
      }
      this.categoryID = index
      const url = 'https://member.med66.com/qzCloud/qzFreePaper/getCopyWriting'
      try {
        const params = {
          params:{
            categoryID:index
          }
        }
        axios.post(url,params).then(resp=>{
          const data = resp.data;
          const { buttonText, isOpen, otherText} = data.result;
          this.buyButtonFlag = isOpen
          this.otherButtonText = otherText
          this.buyButtonText = buttonText

        })
      } catch (error) {
        console.error('获取课程信息失败', error);
      }
      getCategoryMajors(params).then(res => {
        if(res && res.length>0){
          this.majorType = res
          res.forEach(val =>{
            if(val.isChoose===1){
              this.medMajors = val.medMajors
              this.medMajors.forEach((obj,idx1) =>{
                if(obj.isChoose===1){
                  this.majorID = obj.majorID
                  this.courseID = obj.courseID
                  const url = 'https://member.med66.com/qzCloud/qzFreePaper/moKao/getCourseEduAndEduID/'+this.courseID
                  try {
                    axios.get(url).then(resp=>{
                      const data = resp.data;
                      const { courseEduID, eduSubjectID } = data.result;
                      this.courseEduID = courseEduID
                      this.eduSubjectID = eduSubjectID
                    })
                  } catch (error) {
                    console.error('获取课程信息失败', error);
                  }
                  this.getPapersApi(obj.majorID,obj.courseID,obj.siteCourseID,idx1)
                }
              })
            }
          })
        }
      })
      this.kmSwiper.slideTo(idx, 1000, false);
    },
    getPapersApi(majorID,courseID,siteCourseID,index){
      if(this.show){
        this.show = false
      }
      this.paperList = []
      this.medMajors.forEach(val =>{
        if(val.courseID===courseID){
          val.isChoose = 1
          const url = 'https://member.med66.com/qzCloud/qzFreePaper/moKao/getCourseEduAndEduID/'+courseID
          try {
            axios.get(url).then(resp=>{
              const data = resp.data;
              const { courseEduID, eduSubjectID } = data.result;
              this.courseEduID = courseEduID
              this.eduSubjectID = eduSubjectID
            })
          } catch (error) {
            console.error('获取课程信息失败', error);
          }
        }else{
          val.isChoose = 0
        }
      })
      let params = {
        majorID:majorID,
        courseID:courseID,
        siteCourseID:siteCourseID,
        source:'M'
      }
      getPapers(params).then(res => {
        if(res && res.length>0){
          this.paperList = res
          this.subSwiper.slideTo(index, 1000, false);
        }
      })
    },
    jumpToRecord(){
      this.$router.push({
        path:'/record'
      })
    },
    jumpToCollect(){
      this.$router.push({
        path:'/collect'
      })
    },
    openDia(){
      this.show = true
      $(".more-pop").css("margin-top",-($(".more-pop").height()/2));
    },
    closeMask(){
      this.show = false
    },
    //点击进入考场
    goToStep(item){
      let userID = getCookie('cdeluid') || Number(this.$route.query.userID);
      if(userID && userID > 0){
        setCookie("cdeluid", userID);
        if(item.examUrl){
          window.open(item.examUrl);
        }
      }else{
        alert('未登录')
        window.CDEL.islogin()
      }
    },
  }
}
</script>
<style lang="scss">
.limit_btn {
  display: inline-block;
  position: relative;
  z-index: 1;
  height: 32px;
  padding: 0 10px 0 10px;
  color: #fff;
  margin-left: 16px;
  border-radius: 16px;
  background: #651100;
  border: 1px solid transparent;
  background: -webkit-linear-gradient(left, #ab1900, #220901);
  background: -o-linear-gradient(left, #ab1900, #220901);
  background: -moz-linear-gradient(left, #ab1900, #220901);
  background: linear-gradient(to right, #ab1900, #220901);
  line-height: 32px; /* 垂直居中（与 height 相同） */
  text-align: center; /* 水平居中 */
  text-decoration: none; /* 悬停时无下划线 */
  font-size: 14px;
}
.limit_btn:hover {
  text-decoration: none; /* 悬停时无下划线 */
  color: #fff; /* 保持白色，防止变蓝 */
}
.limit_btn .icon {
  position: absolute;
  top: -.3rem;
  right: 0;
  width: 0.85rem;
  z-index: 1000;
  background: transparent;
}
.right-box {
  display: flex;
  align-items: center;
}
.yueKao{
  display: flex;
  text-align: center;
  justify-content: space-around;
  align-items: center;
  height: 1.5rem;
  margin: 0 0.4rem 0.33rem;
  background: linear-gradient( 270deg, #FFF9E9 0%, #FFF9F9 51.8%, #FFF9E6 100%);
  -webkit-box-shadow: 0 5px 6px #efefef; box-shadow: 0 5px 6px #efefef;
  font-size: 13px;
}
.jieSuo{
  background: linear-gradient(30deg, #ef3f0d 0%, #ec6d19 51.8%, #ff7720 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 900;
  margin-right: 20px;
}
.shuZi{
  color: rgba(215, 78, 4, 0.94);
  font-weight: 900;
}
</style>
